import { render, staticRenderFns } from "./CollectorChannelSelect.vue?vue&type=template&id=5899e67f&"
import script from "./CollectorChannelSelect.vue?vue&type=script&lang=js&"
export * from "./CollectorChannelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports